export default {
  E360_LOCALE: 'e360Locale',
  GOOGLE_API_KEY: 'googleApiKey',
  PERSON_DETAILS: 'personDetails',
}
